export const STYLES = {
  iconButton: {width: '24px', height: '24px'},
};
